import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.102 15.867a1.386 1.386 0 0 1 0 1.893 1.386 1.386 0 0 1-1.893 0l-3.951-3.985c-1.361.897-3.022 1.362-4.815 1.13-3.054-.432-5.511-2.923-5.91-5.944C.97 4.445 4.787.627 9.303 1.19c3.021.399 5.512 2.856 5.943 5.91a6.9 6.9 0 0 1-1.129 4.782zM4.123 8.031a4.237 4.237 0 0 0 4.25 4.25 4.26 4.26 0 0 0 4.25-4.25c0-2.324-1.926-4.25-4.25-4.25a4.26 4.26 0 0 0-4.25 4.25"
    }, null, -1)
  ]))]))
}
export default { render: render }